
import $ from "jquery";
import directives from "@/directives";
import filters from "@/filters";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import { ENUM_STATUS_APPLIED } from "@/constants/enum.constant";

@Component({
  filters: filters,
  directives: directives,
})
export default class JobsFairVacancy extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionJobFairCompanyJobDetail", { namespace: "job" })
  private actionJobFairCompanyJobDetail: any;
  @Action("actionJobFairCompanyJobCandidate", { namespace: "job" })
  private actionJobFairCompanyJobCandidate: any;

  // STATE
  @State("locale")
  private locale: any;
  @State("job_fair_company", { namespace: "job" })
  private employer: any;
  @State("job_fair", { namespace: "job" })
  private job_fair: any;
  @State("vacancy", { namespace: "job" })
  private vacancy: any;
  @State("job_fair_candidate", { namespace: "job" })
  private job_fair_candidate: any;

  // PROP

  // INITIALIZATION

  private is_status = ENUM_STATUS_APPLIED;
  private keyword: string = "";

  private created() {
    const { id, job_id } = this.$route.params;

    this.actionJobFairCompanyJobDetail({
      params: {
        job_fair_id: id,
        company_id: this.employer.id,
        job_id: job_id,
      },
      success: (response: any) => {
        this.actionJobFairCompanyJobCandidate({
          params: {
            job_fair_id: id,
            company_id: this.employer.id,
            job_id: job_id,
            params: null,
          },
          success: (response: any) => {},
          fail: (error: any) => {},
        });
      },
      fail: (error: any) => {},
    });
  }

  // METHOD

  private searchCandidate() {
    const { id, job_id } = this.$route.params;

    this.actionJobFairCompanyJobCandidate({
      params: {
        job_fair_id: id,
        company_id: this.employer.id,
        job_id: job_id,
        params: {
          search: this.keyword,
        },
      },
      success: (response: any) => {
        (this.$refs.candidateSearch as any).hide();
      },
      fail: (error: any) => {},
    });
  }

  private clickCandidate(user: any) {
    this.$router.push({ name: "candidateDetail", params: { id: user.id } });
  }

  private limitText(text: string, limit = 200, warper = "...") {
    if (limit > 0) {
      let newText = String($("<div>").html(text).text());
      if (newText.length > limit) {
        return (newText = newText.substring(0, limit) + warper);
      }
      return newText;
    }
    return text;
  }

  private statusDisplay(data: any) {
    if (data == this.is_status.SEEN) {
      return this.$t("seen" )
    } else {
      return this.$t("not_seen")
    }
  }
}
